import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import UFOSegment from '@atlaskit/react-ufo/segment';
import { token } from '@atlaskit/tokens';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { Logo } from '@/libraries/wpl/foundations/src/logo';
import { ProductPageSubNav } from '@/patterns/global-nav/src/nav-product-page';

type EnterprisePageProductNavProps = {
	readonly isActive?: 'overview' | 'success' | 'resources';
};

const logoWrapperStyles = css({
	paddingBlockStart: token('space.025'),
	height: '100%',
});
const EnterpriseLogo = () => (
	<div css={logoWrapperStyles}>
		<Logo brand="enterprise" type="logo" appearance="brand" />
	</div>
);

export const EnterprisePageProductNav = ({ isActive }: EnterprisePageProductNavProps) => {
	const intl = useIntl();

	const ctaButtonText = intl.formatMessage({
		id: 'EnterpriseLandingPage.navbar.cta',
		defaultMessage: 'Contact sales',
	});

	const mobileCtaButtonText = intl.formatMessage({
		id: 'EnterpriseLandingPage.navbar.mobile.cta',
		defaultMessage: 'Contact sales',
	});
	const links = [
		{
			globalLinksKey: 'overview',
			linkText: intl.formatMessage({
				id: 'EnterpriseLandingPage.navbar.overview',
				defaultMessage: 'Overview',
			}),
			hasSubnav: false,
			isActive: isActive === 'overview',
			productKey: 'enterprise',
			href: useLocalizedHref('/enterprise'),
		},
		{
			globalLinksKey: 'success',
			linkText: intl.formatMessage({
				id: 'EnterpriseLandingPage.navbar.success',
				defaultMessage: 'Success',
			}),
			hasSubnav: false,
			isActive: isActive === 'success',
			productKey: 'enterprise',
			href: useLocalizedHref('/enterprise/success'),
		},
		{
			globalLinksKey: 'resources',
			linkText: intl.formatMessage({
				id: 'EnterpriseLandingPage.navbar.resources',
				defaultMessage: 'Resources',
			}),
			hasSubnav: false,
			isActive: isActive === 'resources',
			productKey: 'enterprise',
			href: useLocalizedHref('/enterprise/resources'),
		},
	];

	return (
		<UFOSegment name="enterprise-page-product-navigation">
			<ProductPageSubNav
				productLogoUrl={useLocalizedHref('/enterprise')}
				productLogo={<EnterpriseLogo />}
				productLogoAriaLabel={intl.formatMessage({
					id: 'EnterpriseLandingPage.label',
					defaultMessage: 'Enterprise',
				})}
				mobileLogo={<EnterpriseLogo />}
				productPageNavLinks={links}
				mobileLinksSections={[
					{
						mobileLinkKey: 'mobile-enterprise',
						mobileLinksProps: links,
					},
				]}
				navigationTrynowCtaText={ctaButtonText}
				navigationTrynowCtaUrl={useLocalizedHref('/enterprise/contact?formType=product-features')}
				mobileCtaText={mobileCtaButtonText}
				mobileCtaUrl={useLocalizedHref('/enterprise/contact?formType=product-features')}
			/>
		</UFOSegment>
	);
};

export default EnterprisePageProductNav;
